import { Modal } from "antd";
import { toast } from "react-toastify";
import trans from "../../../utils";
import { useCancelDispatchPlanMutation } from "../../../Redux/service/Dispatcher/DispatcherPlan";

export default function CancelDispatchPlanModal({ plan, onClose }) {
	const [cancelDispatchPlan, { isLoading }] = useCancelDispatchPlanMutation();

	const handleConfirm = async () => {
		try {
			await cancelDispatchPlan(plan.id).unwrap();
			toast.success(trans("Dispatch plan cancelled successfully"), {
				autoClose: 2000,
			});
			onClose();
		} catch (error) {
			toast.error(
				trans(error?.data?.message) || trans("Failed to cancel dispatch plan"),
				{ autoClose: 3000 },
			);
		}
	};

	return (
		<Modal
			open={!!plan}
			title={plan?.name}
			onCancel={onClose}
			maskClosable={false}
			centered
			okText={trans("Cancel Plan")}
			cancelText={trans("Cancel")}
			okButtonProps={{ danger: true, loading: isLoading }}
			onOk={handleConfirm}
		>
			<p>{trans("Are you sure you want to cancel the plan?")}</p>
		</Modal>
	);
}
